import { Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/button.gjs';
import styles from './primary.module.scss';

const METADATA = Metadata.define({
  description: `
    Primary button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Primary Button',
});

export default class SpdsActionButtonPrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-primary';
  variantStyles = styles;
}

export const ACTION_BUTTON_PRIMARY_METADATA = SpdsActionButtonPrimary.metadata;
